import { Clock, Calendar } from "lucide-react";

export const ScheduleStrip = () => {
  return (
    <section
      data-testid="schedule-strip"
      className="bg-[#050505] border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#60A5FA]">
              [ Training Schedule ]
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-12">
            <div className="flex items-center gap-3">
              <Calendar size={18} className="text-[#60A5FA]" />
              <div>
                <div className="text-[10px] tracking-[0.25em] text-white/50 uppercase">
                  Days
                </div>
                <div className="font-display text-lg font-semibold uppercase tracking-tight">
                  Monday – Friday
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Clock size={18} className="text-[#60A5FA]" />
              <div>
                <div className="text-[10px] tracking-[0.25em] text-white/50 uppercase">
                  Hours
                </div>
                <div className="font-display text-lg font-semibold uppercase tracking-tight">
                  12 PM – 5 PM
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScheduleStrip;
